/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 다이얼로그 모달창
 * 버전 : 1.0
 * 파일명 : TapSearchSchoolName.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정일 : 2025-12-30, 강동형, 검색 탭 UI 추가 및 무한스크롤로직 추가
 * 수정일 : 2026-01-30, 강동형, 학과기준 검색기능 API 연결
 * ================================================================ */

import React, { useCallback, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import InputBoxSearch from '../inputbox/InputBoxSearch'
import { Icon_ArrowBack } from '../common/CommonIcons'
import { useNavbarStore } from 'src/stores/UIStore'
import { useDialogStore, useSchoolListDialogStore } from 'src/stores/DialogStore'
import { LoadMapDataShoolName } from './LoadMapData'
import { useSchoolStore } from 'src/stores/SchoolStore'
import Graduate_hat from 'src/assets/images/Graduate_Hat.svg'
import TapSearchSchoolName_SchoolList from './TapSearchSchoolName_SchoolList'
import { ThicDivider } from '../common/Etc'
import { Typography } from '@mui/material'
import { useSearchStore } from 'src/stores/SearchStore'
import { getSchoolMajor } from 'src/api/SchoolService'

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    width: 100%;
    z-index: 20;
    top: 0;
    height: 100vh;
`

const SearchBarWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;

    min-height: 58px;
    padding: 9px 20px;
    background-color: #fff;
    border-bottom: 1px solid #ddd;
`

const ResultWrapper = styled.div<{$isEmpty:boolean}>`
    display: flex;
    justify-content: ${({ $isEmpty }) => ($isEmpty ? 'center' : 'flex-center')};
    align-items: stretch;
    flex-direction: column;

    flex: 1;
    background-color: #F4F4F4;
    width: 100%;
`

const EmptyWrapper = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    gap: 11px;
    flex-direction: column;
    height: 100%;
    padding-bottom: 17vh;
`

const EmptySpan = styled.span`
    text-align: center;
    color: #444;
    font-size: 18px;
    font-weight: 600;
`

const BarWrapper = styled.div`
    background-color: #fff;
    border-bottom: 1px solid #DDDDDD;
`

const TabList = styled.div`
    display: flex;
    gap: 20px;
    width: fit-content;
    padding-left: 20px;
`;

const TabButton = styled.div<{ $selected: boolean }>`
    font-weight: bold;
    color: ${({ $selected }) => ($selected ? "black" : "#7F7F89")};
    border-bottom: 2px solid ${({ $selected }) => ($selected ? "black" : "transparent")};
    padding: 15px 0;
    font-size: 16px;
    cursor: pointer;
`;

const MajorWrapper = styled.div<{$isLast?:boolean}>`
    display: flex;
    justify-content: space-between;
    align-items: center;

    font-size: 16px;
    padding: 14px 20px;
    border-bottom: ${({$isLast})=>($isLast ? 'none': '1px solid #ddd')};
    width: 100%;
    background-color: #fff;
`;


interface Props{
  setTap: React.Dispatch<React.SetStateAction<boolean>>;
}

const TapSearchSchoolName = ({setTap}:Props) => {
    const schoolStore = useSchoolStore.getState().schools
    const setSchoolStore = useSchoolStore((state)=>state.setSchools)
    const total_rows = useDialogStore((state)=>state.total_rows)
    const setNavField = useNavbarStore((state)=>state.setField)
    const setField = useDialogStore((state)=>state.setField)

    const majorTotalRows = useSearchStore(s=>s.totalRow)
    const majorSetField = useSearchStore(s=>s.setField)
    const [majorSchools, setMajorSchools] = useState<any[]>([])

    const [schools,setSchools] = useState<any[]>([])
    const [temp,setTemp] = useState('')
    const [menu,setMenu] = useState<number>(0)

    const dialogSetField = useSchoolListDialogStore((state)=>state.setField)

    useEffect(()=>{
        setNavField('isvisible',false)
        return()=>{
            setNavField('isvisible',true)
            setField('school_name','')
        }
    },[])

    const isMounted = useRef(false);
    useEffect(() => {
    if (isMounted.current) {
        setSchools(schoolStore);
    } else {
        isMounted.current = true;
    }
    }, [schoolStore]);

    const onClickList = (school: any)=>{
        setSchoolStore([school],1)
        dialogSetField('selected',school)
        dialogSetField('isOpen',true)
        setTap(false)
    }

    //무한 스크롤-1
    const loadMoreRef = useRef<HTMLDivElement | null>(null);
    const scrollContainerRef = useRef<HTMLDivElement | null>(null);
    const [refReady, setRefReady] = useState(false);
    const observerRef = useRef<IntersectionObserver | null>(null);

    const setLoadMoreRef = useCallback((node: HTMLDivElement | null) => {
        loadMoreRef.current = node;
          // 둘 다 준비됐으면 isRefsReady true로
        if (node && scrollContainerRef.current) {
            setRefReady(true);
            }
            else {
            setRefReady(false); // ❗ ref 해제 시 false로 초기화
            }
        }, []);
        
        const setLoadScrollRef = useCallback((node: HTMLDivElement | null)=>{
            scrollContainerRef.current = node;
            // 둘 다 준비됐으면 isRefsReady true로
            if (node && loadMoreRef.current) {
            setRefReady(true);
            }
            else {
            setRefReady(false); // ❗ ref 해제 시 false로 초기화
            }
        },[])
                
        useEffect(() => {
            if (!refReady) return;
            const target = loadMoreRef.current;
            const root = scrollContainerRef.current;
            if (!target || !root) {
            return;
            }
                
        const observer = new IntersectionObserver(
            ([entry]) => {
            if (entry.isIntersecting) {
                (async () => {
                LoadMapDataShoolName(false)
                })();
            }
            },
            {
            root: null,
            threshold: 0.1,
            }
        );
                
        observer.observe(target);
        observerRef.current = observer;
        return () => {
            observer.disconnect();
            setRefReady(false)
        };
    }, [refReady]);

    //무한 스크롤-1
    const loadMoreRef2 = useRef<HTMLDivElement | null>(null);
    const scrollContainerRef2 = useRef<HTMLDivElement | null>(null);
    const [refReady2, setRefReady2] = useState(false);
    const observerRef2 = useRef<IntersectionObserver | null>(null);

    const setLoadMoreRef2 = useCallback((node: HTMLDivElement | null) => {
        loadMoreRef2.current = node;
          // 둘 다 준비됐으면 isRefsReady true로
        if (node && scrollContainerRef2.current) {
            setRefReady2(true);
            }
            else {
            setRefReady2(false); // ❗ ref 해제 시 false로 초기화
            }
        }, []);
        
        const setLoadScrollRef2 = useCallback((node: HTMLDivElement | null)=>{
            scrollContainerRef2.current = node;
            // 둘 다 준비됐으면 isRefsReady true로
            if (node && loadMoreRef2.current) {
            setRefReady2(true);
            }
            else {
            setRefReady2(false); // ❗ ref 해제 시 false로 초기화
            }
        },[])
                
        useEffect(() => {
            if (!refReady2) return;
            const target = loadMoreRef2.current;
            const root = scrollContainerRef2.current;
            if (!target || !root) {
            return;
            }
                
        const observer2 = new IntersectionObserver(
            ([entry]) => {
            if (entry.isIntersecting) {
                (async () => {
                    const res = await getSchoolMajor({major_name:temp})
                    setMajorSchools((prev) => [...(prev ?? []), ...(res.data ?? [])]);
                })();
            }
            },
            {
            root: null,
            threshold: 0.1,
            }
        );
                
        observer2.observe(target);
        observerRef2.current = observer2;
        return () => {
            observer2.disconnect();
            setRefReady(false)
        };
    }, [refReady2]);


    const onClickSearch = async ()=>{
        setField('page_Num',1)
        majorSetField('pageNum',1)
        LoadMapDataShoolName(true)
        const res = await getSchoolMajor({major_name:temp})
        setMajorSchools(res.data);
    }


    return (
        <PageWrapper>
            <SearchBarWrapper>
                <Icon_ArrowBack onClick={()=>setTap(false)}/>
                <InputBoxSearch placeholder="검색" onChange={(e)=>{
                setTemp(e.target.value)
                setField('school_name',e.target.value)}} value={temp} onClick={onClickSearch}/>
            </SearchBarWrapper>
            <ResultWrapper $isEmpty={schools.length === 0}>
                {schools.length !== 0 ?
                    <div>
                        <BarWrapper>
                            <ThicDivider/>
                            <TabList>
                                <TabButton $selected={menu === 0} onClick={() => setMenu(0)}>
                                학교정보
                                </TabButton>
                                <TabButton $selected={menu === 1} onClick={() => {setMenu(1)
                                }}>
                                학과정보
                                </TabButton>
                            </TabList>
                        </BarWrapper>
                        {menu === 0 && 
                        <>
                            <Typography variant="body2" sx ={{color:'#7F7F89', fontSize:'12px', fontWeight:500,backgroundColor:'#fff',padding:'10px 20px 0px 20px'}}>
                                총 <span style={{color:'black',fontSize:'16px'}}>{total_rows} </span>건
                            </Typography>
                            <div ref={setLoadScrollRef}>
                            {schools?.map((schools, index)=>(
                                <div onClick={()=>onClickList(schools)}>
                                    <TapSearchSchoolName_SchoolList key={index} school={schools}/>
                                </div>
                            ))}
                            </div>
                            <div ref={setLoadMoreRef} style={{ minHeight: '1px' }}/>
                        </>
                        }
                        {menu === 1 && 
                        <>
                            <Typography variant="body2" sx ={{color:'#7F7F89', fontSize:'12px', fontWeight:500,backgroundColor:'#fff',padding:'10px 20px 0px 20px'}}>
                                총 <span style={{color:'black',fontSize:'16px'}}>{majorTotalRows} </span>건
                            </Typography>
                            <div ref={setLoadScrollRef2}>
                            {majorSchools?.map((schools, index)=>(
                                <MajorWrapper $isLast={majorSchools.length-1 === index} onClick={()=>onClickList(schools)}>
                                    <span style={{fontWeight: 700}}>{schools.major_name}</span>
                                    <span>{schools.school_name}</span>
                                </MajorWrapper>
                            ))}
                            </div>
                            <div ref={setLoadMoreRef2} style={{ minHeight: '1px' }}/>
                        </>
                        }
                    </div>
                :
                    <EmptyWrapper>
                        <img src={Graduate_hat} style={{marginBottom:'11px'}}/>
                        <EmptySpan>검색 결과가 없습니다. <br/>원하는 학교를 검색해보세요.</EmptySpan>
                    </EmptyWrapper>
                }
            </ResultWrapper>
        </PageWrapper>
    )
}

export default TapSearchSchoolName